///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-floor-locations.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportFloorLocationsDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected floorLocations: ReportFloorLocationsCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.floorLocations;
        }

        constructor(model: Dictionary<any>, properties: string[], options) {
            super(model, properties, options.criteria);

            this.floorLocations = new ReportFloorLocationsCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                hiddenValue: options.hiddenValue,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.title = 'LABEL_FLOOR_LOCATION';
            this.allSelectedLabel = 'LABEL_ALL_FLOOR_LOCATION';
            this.totalSelectedMessage = 'LABEL_TOTAL_FLOOR_LOCATIONS_SELECTED';
        }
    }
}
